<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-1">
      <!-- Header -->
      <div class="d-flex align-items-center flex-wrap">
        <!-- Quick Range Buttons -->
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="btn-icon mr-1 my-1"
          @click="fetchData"
        >
          Today
        </b-button>
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="btn-icon mr-1 my-1"
          @click="thisWeekData"
        >
          This Week
        </b-button>
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="btn-icon mr-1 my-1"
          @click="thisMonthData"
        >
          This Month
        </b-button>
        <!-- Custom Date Button -->
        <b-button
          v-ripple.400="'rgba(255,255,255,0.15)'"
          variant="outline-primary"
          class="btn-icon mr-1 my-1"
          ref="customButton"
          @click="openCustomPicker"
        >
          <i class="feather icon-calendar"></i>
          {{ customDateLabel }}

          <!-- Wrapper to attach Flatpickr -->
          <div ref="pickerWrapper" class="flatpickr-wrapper"></div>
        </b-button>

        <!-- Hidden Flatpickr Input -->
        <flat-pickr
          ref="customPicker"
          v-model="dateRange"
          :config="datePickerConfig"
          @on-change="onCustomDateChange"
          class="invisible-picker"
        />
      </div>
      <small class="text-muted"
        >Last updated: {{ new Date().toLocaleString() }}</small
      >
    </div>
    <EcommerceStatistics v-if="dashboardData" :data="dashboardData" />

    <b-overlay :show="isLoading" no-wrap rounded="sm" />
  </div>
</template>

<script>
import { BOverlay } from "bootstrap-vue";
import EcommerceStatistics from "./EcommerceStatistics.vue";
import axios from "@axios";
import FlatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { BButton, BFormGroup } from "bootstrap-vue";

export default {
  components: {
    BOverlay,
    EcommerceStatistics,
    BButton,
    FlatPickr,
    BFormGroup,
  },
  data() {
    return {
      dashboardData: {},
      isLoading: true,
      dateRange: null,
      customDateLabel: "Custom Range",
      datePickerConfig: {
        mode: "range",
        dateFormat: "Y-m-d",
        maxDate: "today",
      },
    };
  },
  beforeMount() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.$store.dispatch("config/getActionPrivilege", "Dashboard-read");
      this.isLoading = true;

      axios
        .get("/Order/api/V1.0/Report/GetDashboardData?filterType=0")
        .then((res) => {
          this.dashboardData = res;
          this.isLoading = false;
          this.customDateLabel = "Custom Range";
        })
        .catch((err) => {
          console.log("Res", err);
          this.isLoading = false;
          this.customDateLabel = "Custom Range";
        });
    },
    thisWeekData() {
      this.$store.dispatch("config/getActionPrivilege", "Dashboard-read");
      this.isLoading = true;
      axios
        .get("/Order/api/V1.0/Report/GetDashboardData?filterType=1")
        .then((res) => {
          this.dashboardData = res;
          this.isLoading = false;
          this.customDateLabel = "Custom Range";
        })
        .catch((err) => {
          console.log("Res", err);
          this.isLoading = false;
          this.customDateLabel = "Custom Range";
        });
    },
    thisMonthData() {
      this.$store.dispatch("config/getActionPrivilege", "Dashboard-read");
      this.isLoading = true;
      axios
        .get("/Order/api/V1.0/Report/GetDashboardData?filterType=2")
        .then((res) => {
          this.dashboardData = res;
          this.isLoading = false;
          this.customDateLabel = "Custom Range";
        })
        .catch((err) => {
          console.log("Res", err);
          this.isLoading = false;
          this.customDateLabel = "Custom Range";
        });
    },
    openCustomPicker() {
      // Trigger Flatpickr programmatically
      this.$refs.customPicker.fp.open();
    },
    onCustomDateChange(selectedDates) {
      if (selectedDates.length === 2) {
        const [start, end] = selectedDates;
        this.customDateLabel = `${this.formatDate(start)} → ${this.formatDate(
          end
        )}`;
        console.log(start);
        console.log(this.formatDate(start));
        // Optionally trigger fetch here
        this.fetchDataByRange(
          `${this.formatDate(start)}`,
          `${this.formatDate(end)}`
        );
      }
    },
    fetchDataByRange(start, end) {
      this.$store.dispatch("config/getActionPrivilege", "Dashboard-read");
      this.isLoading = true;
      axios
        .get(
          `/Order/api/V1.0/Report/GetDashboardData?filterType=3&transactionStartDate=${start}&transactionEndDate=${end}`
        )
        .then((res) => {
          this.dashboardData = res;
          this.isLoading = false;
        })
        .catch((err) => {
          console.log("Res", err);
          this.isLoading = false;
        });
    },
    formatDate(date) {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
  },
};
</script>
<style scoped>
.invisible-picker {
  opacity: 0;
  width: 0;
  height: 0;
  border: none;
  padding: 0;
  margin: 0;
  position: absolute;
  pointer-events: none; /* prevent accidental clicks */
}
</style>
